module.exports = __webpack_public_path__ + "img/Bn1.9cd3bf25.png";